import { gql } from '@urql/core';

import { globalFeatureKeys } from '/src/features/_global/queries';
import { defaultMutationFuction } from '/src/graphql/defaultMutationFuction';

export const upsertUserOnboardingMutation = ({ client, queryClient }) => ({
  mutationFn: ({ startedAt, completedAt, flow, siteUrl, siteTech }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation UpsertUserOnboarding(
          $startedAt: Int
          $completedAt: Int
          $flow: String
          $siteUrl: String
          $siteTech: String
        ) {
          upsertUserOnboarding(
            startedAt: $startedAt
            completedAt: $completedAt
            flow: $flow
            siteUrl: $siteUrl
            siteTech: $siteTech
          ) {
            userId
            onboarding {
              startedAt
              completedAt
              flow
              siteUrl
              siteTech
            }
          }
        }
      `,
      {
        startedAt,
        completedAt,
        flow,
        siteUrl,
        siteTech,
      },
    ),
  onSuccess: () => {
    void queryClient.invalidateQueries({ ...globalFeatureKeys.me });
  },
});
